/**
 * FELVORA — ago-2026 · FORMULARIO GENÉRICO DEL BIEN.
 *
 * Pinta UN campo declarado por el catálogo de la actividad
 * (`av_actividad_config.bien_campos`). Ninguna pantalla vuelve a escribir a mano los
 * campos de un inmueble: al declarar los campos de una actividad en el panel, su
 * formulario aparece solo.
 *
 * Tipos soportados: texto · textarea · numero · moneda · fecha · opcion · cliente · asesor.
 */
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from "@/components/ui/select";

const ANCHO_COMPLETO = new Set(["textarea", "cliente", "asesor"]);

export function CampoBien({ campo, valor, onChange, clientes = [], asesores = [] }) {
  const { clave, label, tipo, opciones = [], requerido, ayuda, ancho } = campo;
  const testid = `bien-campo-${clave}`;
  const num = (e) => onChange(clave, parseFloat(e.target.value) || 0);

  const control = () => {
    switch (tipo) {
      case "textarea":
        return <Textarea data-testid={testid} value={valor || ""}
                         onChange={(e) => onChange(clave, e.target.value)} />;
      case "numero":
      case "moneda":
        return <Input type="number" data-testid={testid} value={valor ?? 0} onChange={num} />;
      case "fecha":
        return <Input type="date" data-testid={testid} value={valor || ""}
                      onChange={(e) => onChange(clave, e.target.value)} />;
      case "opcion":
        return (
          <Select value={valor || ""} onValueChange={(v) => onChange(clave, v)}>
            <SelectTrigger data-testid={testid}><SelectValue placeholder="Selecciona…" /></SelectTrigger>
            <SelectContent>
              {opciones.map((o) => (
                <SelectItem key={o} value={o} className="capitalize">
                  {String(o).replace(/_/g, " ")}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        );
      case "cliente":
        return (
          <Select value={valor || ""} onValueChange={(v) => onChange(clave, v)}>
            <SelectTrigger data-testid={testid}>
              <SelectValue placeholder="Selecciona un cliente…" />
            </SelectTrigger>
            <SelectContent>
              {clientes.map((c) => (
                <SelectItem key={c.id} value={c.id}>{c.nombre || c.razon_social} — {c.rfc || "(sin RFC)"}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        );
      case "asesor":
        return (
          <Select value={valor || "__none__"}
                  onValueChange={(v) => onChange(clave, v === "__none__" ? "" : v)}>
            <SelectTrigger data-testid={testid}><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__none__">Sin asignar</SelectItem>
              {asesores.map((a) => (
                <SelectItem key={a.id} value={a.id}>
                  {a.name || a.nombre}{a.email ? ` — ${a.email}` : ""}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        );
      default:
        return <Input data-testid={testid} value={valor || ""}
                      onChange={(e) => onChange(clave, e.target.value)} />;
    }
  };

  return (
    <div className={(ANCHO_COMPLETO.has(tipo) || ancho === "completo") ? "md:col-span-2" : ""}>
      <label className="text-sm" data-testid={`bien-label-${clave}`}>
        {label}{requerido ? " *" : ""}
      </label>
      {control()}
      {ayuda ? <p className="mt-1 text-xs text-slate-500">{ayuda}</p> : null}
    </div>
  );
}
